import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { ArrowTabsNavData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const ArrowTabsNavContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {ArrowTabsNavData &&
        ArrowTabsNavData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default ArrowTabsNavContent;
